import APIUpdateAward from "@services/Award/updateAward";
import APIUpdateMedia from "@services/Media/updateMedia";
import APIUpdateNews from "@services/News/updateNews";
import APIUpdatePartner from "@services/Partner/updateItem";
import APIUpdateWebinar from "@services/Webinar/updateWebinar";

export const apiUpdateModuleMap = {
  partner: APIUpdatePartner,
  webinar: APIUpdateWebinar,
  news: APIUpdateNews,
  award: APIUpdateAward,
  media: APIUpdateMedia,
};
